import {createSlice} from '@reduxjs/toolkit';
import {deleteCustomJob} from "../serverREST";
import {
    invalidTextSearchItem,
    createItems,
    removeJobFromItems,
} from './textSearchItems.js'

export const listsSlice = createSlice({
    name: 'listsReducer',
    initialState: {
        loggedIn: false,
        collapseLogInAlertCode: 0,
        makes: [],
        series: [],
        models: [],
        fuels: [],
        displacements: [],
        textSearchJobs: [],
        textSearchItems: [invalidTextSearchItem],
        allDetails: [],
        operationsDict: {},
        workOrders: [],
        showLoader: false,
        carJobs: [],
        systems: [],
        carLoader: {
            makes: false,
            series: false,
            models: false,
            fuels: false,
            displacements: false

        },
        listSearch: {
            "success": [],
            "search": [],
        }
    },
    reducers: {
        setListsSearch: (state, action) => {
            const {orders, status} = action.payload;
            if (!state.listSearch[status]) return;
            state.listSearch[status] = orders;
        },
        addListsSearch: (state, action) => {
            const {order, status} = action.payload;
            if(state.listSearch["search"].length !== 0){
                const index = state.listSearch["search"].findIndex(
                    item => item.workorder_id === order.workorder_id
                );
                if (index !== -1) {
                    state.listSearch["search"][index] = order;
                }
            }
            if (!state.listSearch[status]) return;
            state.listSearch[status].unshift(order);
        },
        setSystems: (state, action) => {
            state.systems = action.payload;
        },
        setCollapseLogInAlertCode: (state, action) => {
            state.collapseLogInAlertCode = action.payload;
        },
        setLoggedIn: (state, action) => {
            // console.log(action.payload)
            state.loggedIn = action.payload;
        },
        setMakes: (state, action) => {
            state.makes = action.payload;
        },
        setSeries: (state, action) => {
            state.series = action.payload;
        },
        setModels: (state, action) => {
            state.models = action.payload;
        },
        setFuels: (state, action) => {
            state.fuels = action.payload;
        },
        setCarJobs: (state, action) => {
            state.carJobs = action.payload;
        },
        setLoaderCar: (state, action) => {
            const {loader, value} = action.payload;
            if (state.carLoader.hasOwnProperty(loader)) {
                state.carLoader[loader] = value;
            }
        },

        setTextSearchJobs: (state, action) => {
            action.payload.forEach((item) => {
                if (!item.other) {
                    item.other = ""
                }
            })
            action.payload.reverse()
            let uniqueArray = action.payload.filter(function (item, pos) {
                let first_index = action.payload.findIndex((element) => {
                    // let element_string =  + element.detail.part_name
                    return element.detail.part_name === item.detail.part_name &&
                        element.operation.operation_name === item.operation.operation_name &&
                        element.other === item.other
                })
                return first_index === pos;
            })
            uniqueArray.reverse()
            // console.log(uniqueArray)
            state.textSearchJobs = uniqueArray;

            state.textSearchItems = [invalidTextSearchItem, ...createItems(state.textSearchJobs)];
        },
        setDisplacements: (state, action) => {
            state.displacements = action.payload;
        },
        setListsEmpty: (state, action) => {
            state.makes = [];
            state.series = [];
            state.models = [];
            state.fuels = [];
            state.textSearchJobs = [];
            state.textSearchItems = [invalidTextSearchItem];
            state.displacements = [];
        },
        setAllDetails: (state, action) => {
            state.allDetails = action.payload;
        },
        setOperations: (state, action) => {
            state.operationsDict[action.payload.index] = action.payload.operations
        },
        deleteJobFromTextSearchJobs: (state, action) => {
            const targetJobId = action.payload;

            const jobIndex = state.textSearchJobs.findIndex(job => job.job_id === targetJobId);
            if (jobIndex >= 0) {
                removeJobFromItems(state.textSearchItems, state.textSearchJobs[jobIndex]);
                state.textSearchJobs.splice(jobIndex, 1);
            }
            const jobCarIndex = state.carJobs.findIndex(job => job.job_id === targetJobId);
            if (jobCarIndex >= 0) {
                state.carJobs.splice(jobCarIndex, 1);
            }
            deleteCustomJob(targetJobId);
        },
        setWorkOrders: (state, action) => {
            state.workOrders = action.payload;
        },
        setShowLoader: (state, action) => {
            state.showLoader = action.payload;
        },
        removeOrder: (state, action) => {
            state.workOrders = state.workOrders.filter(
                order => order.workorder_id !== action.payload
            )
        }
    },
});

export const {
    setCollapseLogInAlertCode,
    setLoggedIn,
    setMakes,
    setSeries,
    setModels,
    setFuels,
    setDisplacements,
    setTextSearchJobs,
    setListsEmpty,
    setAllDetails,
    setOperations,
    deleteJobFromTextSearchJobs,
    setWorkOrders,
    setShowLoader,
    setSystems,
    setCarJobs,
    setLoaderCar,
    removeOrder,
    setListsSearch,
    addListsSearch

} = listsSlice.actions;

export default listsSlice.reducer;
